export default __webpack_public_path__ + "static/media/wex-logo-gray-400.f28d8862.svg";